import { ToggleIconContainer } from "./ElementsRowStyles";
import Image from "next/image";
import React, { Dispatch, SetStateAction } from "react";

export default function ExpandRowsToggle({
  groupIndex,
  groupLength,
  groupIsExpanded,
  setGroupIsExpanded,
}: {
  groupIndex: number;
  groupLength: number;
  groupIsExpanded: boolean;
  setGroupIsExpanded: Dispatch<SetStateAction<boolean>>;
}) {
  if (groupLength == 1) {
    return null;
  }
  if (groupIndex > 0) {
    return (
      <Image src="/icons/list_child.svg" alt="Retract" width="10" height="10" />
    );
  }
  return (
    <ToggleIconContainer onClick={() => setGroupIsExpanded(!groupIsExpanded)}>
      {groupIsExpanded ? (
        <Image
          src="/icons/retract_red.svg"
          alt="Retract"
          width="10"
          height="10"
        />
      ) : (
        <Image
          src="/icons/expand_red.svg"
          alt="Expand"
          width="10"
          height="10"
        />
      )}
    </ToggleIconContainer>
  );
}
